import { render, staticRenderFns } from "./_reportAttachmentsRibbon.vue?vue&type=template&id=64f78eb4"
import script from "./_reportAttachmentsRibbon.vue?vue&type=script&lang=js"
export * from "./_reportAttachmentsRibbon.vue?vue&type=script&lang=js"
import style0 from "./_reportAttachmentsRibbon.vue?vue&type=style&index=0&id=64f78eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports